import React from "react";

const MapTab = () => {
  return <div>MapTab</div>;
};

export default MapTab;
